



































































import { SensitivityLevelHelper } from "@/common/models";
import { SharedState } from "@/common/state";
import DropDownSimple from "@/components/dropdown/DropDownSimple.vue";
import InfoTypes from "@/components/filters-bar/InfoTypes.vue";
import { computed, onMounted, Ref, ref } from "@vue/composition-api";
import Vue from "vue";
export default Vue.extend({
  components: { DropDownSimple, InfoTypes },
  props: ["sentence", "variables", "keep_const"],
  setup(props, { emit }) {
    const vars: Ref<Record<string, { id: string; name: string }>> = ref({});

    const current_select_info_types_ids = computed(() => {
      if (vars.value["{~label}"]) {
        return [vars.value["{~label}"].id];
      } else {
        return [""];
      }
    });

    const on_all_labels_changes = (ids: string[]) => {
      if (ids.length === 0) {
        vars.value["{~label}"] = { id: "", name: "" };
      } else {
        vars.value["{~label}"] = {
          id: ids[0],
          name: SharedState.getInfoType(ids[0])!.labelName,
        };
        vars.value = Object.entries(vars.value).reduce((acc, [k, v]) => {
          acc[k] = get_value_from_variants(k, v.id);
          return acc;
        }, {} as Record<string, { id: string; name: string }>);
      }
      console.log("on_all_labels_changes ::", vars.value);
      recalculate_vars();
      emit("on_var_change");
    };

    const get_value_from_variants = (
      key: string,
      value: string
    ): { id: string; name: string } => {
      if (key === "{~label}") {
        const label = SharedState.getInfoType(value)!;
        return { id: label.id, name: label.labelName };
      } else {
        return displayed_variants.value[key].find((f) => f.id === value)!;
      }
    };

    const on_var_value_change = (
      var_key: string,
      val: { id: string; name: string }
    ) => {
      console.log("on_var_value_change : ", var_key, val);
      vars.value[var_key] = displayed_variants.value[var_key].find(
        (f) => f.id === val.id
      )!;
      recalculate_vars();
      vars.value = Object.entries(vars.value)
        .filter(([k, v]) => k && v)
        .reduce((acc, [k, v]) => {
          acc[k] = get_value_from_variants(k, v.id);
          return acc;
        }, {} as Record<string, { id: string; name: string }>);
      emit("on_var_change");
    };

    const parsed_sentence = computed(() =>
      (props.sentence as string).split(" ").map((w) => {
        return {
          word: w,
          type: w.startsWith("{~") ? "variable" : "word",
        };
      })
    );

    const replace_label = (
      variant_key: string,
      variant_id: string,
      phrase: string
    ) => {
      const l = SharedState.getInfoType(variant_id);
      if (!l) {
        return phrase;
      }
      let res = "";
      const { labelName, parentId, sensitivityLevel } = l;
      const { labelName: parent_name } =
        SharedState.getInfoType(parentId || "") || {};
      switch (variant_key) {
        case "{~v_label}":
          res = phrase
            .replace("{~v_label}", labelName)
            .replace("{~info_type}", parent_name);
          break;
        case "{~info_type}":
          res = phrase.replace("{~info_type}", labelName);
          break;
        case "{~label}":
          res = phrase
            .replace("{~label}", labelName)
            .replace(
              "{~v_label}",
              `${SensitivityLevelHelper.intToString(
                sensitivityLevel
              )} sensitive ${labelName}`
            )
            .replace("{~info_type}", parent_name || labelName);
          break;
        default:
          res = phrase;
          break;
      }
      console.log(
        "replace_label ::",
        variant_key,
        variant_id,
        phrase,
        " ::: ",
        res
      );
      return res;
    };

    const get_sentence_variants = (str: string): [string[], string] => {
      const all_vars = Array.from(str.match(/{[^}]+}/g)!);
      return [
        all_vars,
        all_vars.find((v) =>
          ["{~v_label}", "{~label}", "{~info_type}"].includes(v)
        )!,
      ];
    };

    const displayed_variants: Ref<Record<
      string,
      { id: string; name: string }[]
    >> = ref({});

    const recalculate_vars = () => {
      const [sentence_variants, label_variant] = get_sentence_variants(
        props.sentence as string
      );
      const variables = props.variables as Record<
        string,
        Array<{ id: string; name: string }>
      >;
      if (!label_variant) {
        return variables;
      }
      displayed_variants.value = {
        ...variables,
        ...sentence_variants.reduce(
          (
            acc: Record<string, Array<{ id: string; name: string }>>,
            k: string
          ) => {
            const selected_id = vars.value[label_variant]?.id;

            if (k === "{~label}") {
              acc[k] = variables[k];
            } else {
              acc[k] = variables[k].map(({ id, name }) => {
                return {
                  id,
                  name: replace_label(label_variant, selected_id, name),
                };
              });
            }
            return acc;
          },

          {} as Record<string, Array<{ id: string; name: string }>>
        ),
      };
    };

    onMounted(() => {
      console.log("BUBU::", props.variables);
      vars.value =
        // @ts-ignore
        parsed_sentence.value
          .filter((d: any) => d.type === "variable")
          // @ts-ignore
          .reduce((acc, d) => {
            // @ts-ignore
            const initial_val = props.variables[d.word][0];
            // @ts-ignore
            acc[d.word] = initial_val;
            return acc;
          }, {});
      console.log("vars.value  : ", vars.value);
      recalculate_vars();
    });

    /**
     * @public
     * */
    const get_vars = () => {
      return Object.entries(vars.value).reduce((acc, [key, val]) => {
        acc[key] = val.id;
        return acc;
      }, {} as Record<string, string>);
    };

    const set_vars = (selected_vars: Record<string, string>) => {
      console.log("selected_vars : ", selected_vars);
      Object.entries(selected_vars).forEach(([k, v]) => {
        // @ts-ignore
        const selected_var = props.variables[k].find((d) => d.id === v);
        console.log("selected_var : ", selected_var);
        if (selected_var) {
          on_var_value_change(k, selected_var);
        }
      });
      recalculate_vars();
    };

    return {
      get_vars,
      set_vars,
      vars,
      current_select_info_types_ids,
      on_all_labels_changes,
      displayed_variants,
      parsed_sentence,
      on_var_value_change,
    };
  },
});
